import React, { Component } from 'react';
import classNames from 'classnames';
import { withRouter } from 'react-router';
import withFetch from '../../hoc/withFetch';
import withAuthProvider from '../../hoc/withAuthProvider';
import Takeover from '../takeover';
import { Button } from '../forms';
import Edit from './edit';
import SaveButton from '../report/save-button';
import Success from '../spinner/success';
import SpinnerDots from '../spinner/dots';
import { REACT_APP_API_BASE} from '../../config';

class Scenarios extends Component {
    
    state = {
        value: '',
        view: 'start',
        deleteItem: null,
        items: null,
        isLoading: true,
        isUpdated: false,
        isFinished: false,
        isSaved: false,
        isSaving: false
    }
    
    async componentDidUpdate() {
        if (!this.props.isAuthenticated) return;

        if (this.state.items) return;

        const rawRes = await this.props.fetch(`${REACT_APP_API_BASE}/salesdistrictscenario/${this.props.type}/edit`);
        const { scenarios } = await rawRes.json();

        const items = scenarios.map((item, i) => {
            return {
                ...item,
                id: i+1
            };
        });

        this.setState({
            items,
            isLoading: false
        });
    }

    updateName(id, name) {
        const updatedItems = this.state.items.map(item =>
            item.id === id ? { ...item, name: name }
              : item
        );

        this.setState({
            items: [...updatedItems]
        });
    }

    addNewScenario() {
        this.setState({
            isLoading: true,
            isCopying: true
        });


        if (this.state.value === '') return;

        const id = this.state.items.length === 0 ? 0 : Math.max.apply(Math, this.state.items.map((o) => o.id ));

        this.setState({
            items: [{
                salesDistrictScenarioId: 0,
                id: id+1,
                name: this.state.value,
                sortOrder: 1
            }, ...this.state.items.map(item => {
                return {
                    ...item,
                    sortOrder: item.sortOrder+1
                }
            })],
            value: ''
        }, async () => {
            const headers = await this.getTokenHeaders();
            const saveResponse = await fetch(`${REACT_APP_API_BASE}/salesdistrictscenario/${this.props.type}/edit`, {
                                            method: 'POST',
                                            headers: headers,
                                            body: JSON.stringify({
                                                scenarios: this.state.items
                                            })
                                        });
        
            if (saveResponse.ok) {
                const { scenarios }  = await saveResponse.json();
                const items = scenarios.map((item, i) => {
                    return {
                        ...item,
                        id: i+1
                    };
                });
               
                this.setState({
                    isLoading: false,
                    isCopying: false,
                    items
                });

            }
        });
    }

    changeView(view, deleteItem = null) {
        this.setState({
            deleteItem,
            view
        });
    }

    async deleteScenario(scenarioId, id) {
        this.setState({
            isLoading: true
        });
        
        if (this.state.deleteItem.salesDistrictScenarioId === 0) {
            //Client
            this.setState({
                items: [...this.state.items.filter(item => item.id !== this.state.deleteItem.id)],
                deleteItem: null,
                view: 'finished',
                isFinished: true,
                isLoading: false
            });
        } else {
           
            //Backend
            const headers = await this.getTokenHeaders();
            const rawResponse = await fetch(`${REACT_APP_API_BASE}/salesdistrictscenario/${this.props.type}/delete/${this.state.deleteItem.salesDistrictScenarioId}`, {
                method: 'DELETE',
                headers: headers
            });

            if (rawResponse.ok) {
                const { scenarios } = await rawResponse.json();

                 //Sync backend state with frontend state
                const items = this.state.items.filter(item => {
                    if (item.salesDistrictScenarioId === 0) return true;

                    return scenarios.find(backendItem => backendItem.salesDistrictScenarioId === item.salesDistrictScenarioId) ? true : false;
                });
               
                this.setState({
                    items,
                    deleteItem: null,
                    view: 'finished',
                    isFinished: true,
                    isLoading: false
                });

            }
        }
    }

    getHeadingText() {
        if (this.state.view ===  'start') {
            return 'Nytt/Ändra scenario';
        }

        if (this.state.view ===  'delete') {
            return 'Radera scenario';
        }

        if (this.state.view ===  'finished') {
            return 'Klart!';
        }

        return '';
    }

    getDeleteItem() {
        const item = this.state.items.find(item => item.id === this.state.deleteItem.id);
        if (!item) return '';

        return item.name;
    }

    async getTokenHeaders() {
        const token = await this.props.getAccessToken();
        const headers = new Headers();
        const bearer = `Bearer ${token}`;
        headers.append('Authorization', bearer);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');

        return headers;
    }

    async save() {
        this.setState({
            isLoading: true,
            isSaving: true
        });

        const headers = await this.getTokenHeaders();
        const path = `${REACT_APP_API_BASE}/salesdistrictscenario/${this.props.type}/edit`;
        const rawResponse = await fetch(path, {
                                        method: 'POST',
                                        headers: headers,
                                        body: JSON.stringify({
                                            scenarios: this.state.items
                                        })
                                    });
    
        if (rawResponse.ok) {
            this.setState({
                isSaved: true,
                isSaving: false,
                isLoading: false,
                view: 'start'
            }, () => {
                setTimeout(() => {
                    const { location } = this.props;
                    window.location.href = location.pathname;
                }, 1000);
            });
        }
    }

    async copy(id) {
        this.setState({
            isLoading: true,
            isCopying: true
        });

        const headers = await this.getTokenHeaders();
        const saveResponse = await fetch(`${REACT_APP_API_BASE}/salesdistrictscenario/${this.props.type}/edit`, {
                                        method: 'POST',
                                        headers: headers,
                                        body: JSON.stringify({
                                            scenarios: this.state.items
                                        })
                                    });
    
        if (saveResponse.ok) {

            const savedItems  = await saveResponse.json();

            this.setState({
                items: savedItems.scenarios
            }, async () => {
                const path = `${REACT_APP_API_BASE}/salesdistrictscenario/copy/${id}`;
                const rawResponse = await fetch(path, {
                                                method: 'POST',
                                                headers: headers
                                            });
                if (rawResponse.ok) {
                    const newCopy =  await rawResponse.json();
                    const rawRes = await this.props.fetch(`${REACT_APP_API_BASE}/salesdistrictscenario/${this.props.type}/edit`);
                    const { scenarios } = await rawRes.json();
                    const items = scenarios.map((item, i) => {
                            return {
                                ...item,
                                id: i+1,
                                isNewCopy: item.salesDistrictScenarioId === newCopy.id
                            };
                        });
            
                        this.setState({
                            items,
                            isLoading: false,
                            isCopying: false
                        }, () => {
                            setTimeout(() => {
                                const updateItems = items.map((item) => {
                                    return {
                                        ...item,
                                        isNewCopy: false
                                    };
                                });
            
                                this.setState({
                                    items: updateItems
                                });
                            }, 1000);
                        });
                    }  
                }
            );
        }
           
    }
    
    render() {
        return (
            <Takeover isOpen={this.props.isOpen} toggleTakeover={() => {
                this.props.toggleTakeover(false);
                this.changeView('start');
            }} heading={this.getHeadingText()} modifiers={{
                'takeover--no-margin': true
            }}>
                <div className={classNames({
                    'districts__takeover-content': true,
                    'districts__takeover-content--is-loading': this.state.isLoading,
                    'districts__takeover-content--is-copying': this.state.isCopying
                })}>
                    {this.state.view === 'start' &&
                        <>
                            <div className="districts__add-new">
                                <input disabled={this.state.isLoading} type="text" maxLength="100" placeholder="Skapa nytt scenario..." onChange={(e) => this.setState({ value: e.currentTarget.value })} value={this.state.value} />
                                <button disabled={this.state.isLoading} className="districts__add-new-btn" type="button" onClick={() => this.addNewScenario()}>Lägg till</button>
                            </div>
                            {this.state.items &&
                                <Edit changeView={(view, id) => this.changeView(view, id)} 
                                      updateName={(id, name) => this.updateName(id, name)} 
                                      copy={(id) => this.copy(id)}
                                      items={this.state.items} 
                                      isCopying={this.state.isCopying}
                                      setItems={(sortItems) => {
                                          const tempItems = sortItems(this.state.items);
                                          const items = tempItems.map((item, i) => {
                                              return {
                                                  ...item,
                                                  sortOrder: i+1
                                              }
                                          });
                                         
                                          this.setState({
                                              items
                                          });
                                      }} />
                            }
                        
                            <div className="create-district-map__forms-footer">
                                <SaveButton onClick={() => this.save()} 
                                            isLoading={this.state.isSaving}
                                            isSaved={this.state.isSaved} 
                                            text="Spara scenarios" 
                                            textSaving="Sparar scenarios"
                                            textSaved="Scenarios sparades!"
                                            attr={{
                                                disabled: this.state.isSaving
                                            }}
                                            modifiers={{
                                                'create-district-map__create': true,
                                                'report-save-btn--centered': true
                                            }} />
                                <Button type="button" 
                                    modifiers={{
                                        'form__button--muted': true,
                                        'form__button--centered': true
                                    }}
                                    onClick={() => this.props.toggleTakeover(false)}>Avbryt</Button>
                            </div>
                        </>
                    }
                
                    {this.state.view === 'delete' &&
                        <>
                            <div className="districts__edit-confirm">
                                <p>Vill du ta bort scenariot <strong>{this.getDeleteItem()}</strong> permanent? Alla dina säljdistrikt i <strong>{this.getDeleteItem()} kommer också att raderas!</strong></p>
                                <div className="districts__edit-confirm-buttons">
                                    <button disabled={this.state.isLoading} onClick={() => this.deleteScenario()} type="button" className="districts__takeover-controls-btn districts__takeover-controls-btn--danger">Radera scenario</button>
                                    <button disabled={this.state.isLoading} onClick={() => this.setState({ view: 'start' })} type="button" className="districts__takeover-controls-btn districts__takeover-controls-btn--outline">Avbryt</button>
                                </div>
                            </div>
                        </>
                    }

                    {this.state.view === 'finished' &&
                        <>
                            <div className={classNames({
                                'districts__takeover-success': true,
                                'districts__takeover-success--is-finished': this.state.isFinished
                            })}>
                                <Success isFinished={this.state.isFinished} />
                                <div className="districts__takeover-controls">
                                    <button onClick={() => this.setState({
                                        view: 'start',
                                        isFinished: false
                                    })} className="districts__takeover-controls-btn districts__takeover-controls-btn--outline" type="button">Tillbaka</button>
                                    <Button type="button" 
                                            modifiers={{
                                                'form__button--muted': true,
                                                'form__button--centered': true
                                            }}
                                            onClick={() => this.props.toggleTakeover(false)}>Stäng</Button>
                                </div>
                            </div>
                        </>
                    }
                    <SpinnerDots />
                </div>
            </Takeover>
        );
    }
};

export default withAuthProvider(withFetch(withRouter(Scenarios)));